import { CloseOutlined } from '@ant-design/icons';
import { LocationPin } from '@mui/icons-material';
import { Card, Divider, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { ApiHandler } from '../services/apiHandler';
import ErrorAlert from './ErrorAlert';
import Spinner from './Spinner';

interface VenueListProps {
  goBack: (page: string) => void;
  onVenueSelected: (venue_id: string, location: { lat: number; lng: number }, boundsPolygon: any[]) => void;
}

const VenueList: React.FC<VenueListProps> = (props) => {
  const [venues, setVenues] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: '', alert: false });
  useEffect(() => {
    getVenues();
  }, []);

  const getVenues = () => {
    setLoading(true);
    ApiHandler({ apiName: 'listVenues', params: {}, body: {} })
      .then((res) => {
        setVenues(res?.data?.venues);
      })
      .catch((error: any) => {
        setError({ message: error.message ?? 'Something went wrong', alert: true });
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="h-100 overflow-auto">
      <div className="app-card position-relative app-card-size right">
        <div className="row-wise vertical-center space-between px-4 py-3">
          <span className="app-card-action-heading fw-bold">{'VENUES'}</span>
          <div
            onClick={() => {
              props.goBack('home');
            }}>
            <CloseOutlined className="fs-6" />
          </div>
        </div>
        <div className="border-bottom" />
        <div className="overflow-auto p-3">
          {venues?.map((venue) => (
            <Card
              key={venue.id}
              className="d-flex flex-col cursor-pointer mb-2"
              onClick={() => {
                props.onVenueSelected(venue?.id, venue?.location_point, venue?.polygon_points);
              }}>
              <Typography.Title level={5}>{venue?.name}</Typography.Title>
              {venue?.description && <Typography.Text className="text-muted">{venue?.description}</Typography.Text>}
              <Divider className="w-100" />
              {venue?.address && (
                <div className="d-flex flex-row gap-2 align-items-center mb-2">
                  <LocationPin className="text-muted fs-6" />
                  <Typography.Text>{venue?.address}</Typography.Text>
                </div>
              )}
              <Typography.Text type="secondary" style={{ fontStyle: 'italic' }}>
                {venue?.total_buildings} buildings
              </Typography.Text>
            </Card>
          ))}
        </div>
      </div>
      <ErrorAlert show={error.alert} onDismiss={() => setError({ message: '', alert: false })} message={error.message} />
      <Spinner show={loading} />
    </div>
  );
};

export default VenueList;
